import script from "./ChatAction.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatAction.vue?vue&type=script&setup=true&lang=js"

import "./ChatAction.vue?vue&type=style&index=0&id=66e42126&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66e42126"]])

export default __exports__